import { addRange, max } from "../linqSimulation";

/**
 * Рекурсивно очищает все NaN значения из объекта pdfmake
 * @param {any} obj - объект для очистки
 * @returns {any} - очищенный объект
 */
export function sanitizeNaNValues(obj) {
    if (obj === null || obj === undefined) {
        return obj;
    }

    if (Array.isArray(obj)) {
        return obj.map(item => sanitizeNaNValues(item));
    }
 //////
    if (typeof obj === 'number') {
        // Заменяем NaN и Infinity на 0
        if (isNaN(obj) || !isFinite(obj)) {
            return 0;
        }
        return obj;
    }

    if (typeof obj === 'object') {
        const sanitized = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const value = obj[key];
                
                // Специальная обработка для массивов margin/padding
                if ((key === 'margin' || key === 'padding') && Array.isArray(value)) {
                    sanitized[key] = value.map(v => {
                        if (typeof v === 'number' && (isNaN(v) || !isFinite(v))) {
                            return 0;
                        }
                        return sanitizeNaNValues(v);
                    });
                } else if (key === 'widths' && Array.isArray(value)) {
                    // widths может содержать числа, строки ("auto", "*") или объекты
                    sanitized[key] = value.map(v => {
                        if (typeof v === 'number' && (isNaN(v) || !isFinite(v))) {
                            return 'auto';
                        }
                        return sanitizeNaNValues(v);
                    });
                } else {
                    // Рекурсивно обрабатываем вложенные объекты
                    sanitized[key] = sanitizeNaNValues(value);
                }
            }
        }
        return sanitized;
    }

    return obj;
}

export function normalizeTable(node, rowIndex, columnIndex) {
    let body = node?.table?.body;
    let widths = node?.table?.widths;    

    if (!body) {
        if (node.nodeName == 'IMG') {       
            if (node.image && node.image.indexOf('file:///') >= 0) {
                node.nodeName = 'SPAN';
                node.text = '';
                node.image = '';
                node.style = '';
            }
        }

        normalizeStack(node, rowIndex, columnIndex);
        return;
    }

    if (Array.isArray(body) && body.length == 0) {
        node.nodeName = 'SPAN';
        node.text = '';
        node.image = '';
        node.style = '';
        node.table = undefined;
        return;
    }
    
    body = Array.isArray(body) ? body : [body];
    widths = widths ? (Array.isArray(widths) ? widths : [widths]) : null; 

    for (let i = 0; i < body.length; i++) {
        const item = body[i];
        if (widths != null) {
            const width = widths[i];
            normalizeTableBody(item, width, rowIndex, columnIndex);
        } else
            normalizeTableBody(item, null, rowIndex, columnIndex);
    }

    // const tr = node?.table?.body[0];
    // node.table.body = [[tr[0]]];

    if (rowIndex != null) {
        const slice = [];
        for (let i = rowIndex[0]; i <= rowIndex[1]; i++)
            slice.push(node.table.body[i]);
        node.table.body = slice;
    }

    normalizeTableBody(node?.table?.body, node?.table?.widths, rowIndex);
}

export function normalizeStack(node, rowIndex, columnIndex) {
    const stack = node.stack;

    if (!stack || !stack.length)
        return;

    for (let i = 0; i < stack.length; i++) {
        const node = stack[i];
        normalizeTable(stack[i], rowIndex, columnIndex);
    }
}

function normalizeTableBody(body, widths, rowIndex, columnIndex) {
    const maxRowLength = max(body, _ => _.length);

    for (let i = 0; i < body.length; i++) {
        const row = body[i];

        if (row.length < maxRowLength) {
            while (row.length < maxRowLength) {
                row.push({ text: "" });
            }
        }

        if (rowIndex != null && row?.rowSpan != null) {
            row.rowSpan = null;
        }

        if (columnIndex != null && row?.colSpan != null) {
            row.colSpan = null;
        }
           
        if (row.stack) {
            normalizeStack(row, rowIndex, columnIndex);
        }
    }

    if (columnIndex != null) {
        const slice = [];
        for (let i = columnIndex[0]; i <= columnIndex[1]; i++)
            slice.push(body[i]);
        body.length = 0;
        addRange(body, slice);
    }

    if (widths?.length < maxRowLength) {
        while (widths.length < maxRowLength) {
            widths.push({ width: "auto" });
        }
    }
}

/**
 * Переводит ширины колонок таблицы в проценты и задаёт ширину таблицы 100%,
 * чтобы таблица растягивалась по ширине контента (для field.align).
 * @param {object} node - узел pdfmake с node.table.widths (массив чисел или строк)
 */
export function convertTableWidthsToPercent(node) {
    const widths = node?.table?.widths;
    if (!Array.isArray(widths) || widths.length === 0) return;
    const numWidths = widths.map((w) => {
        if (typeof w === 'number' && isFinite(w)) return w;
        if (typeof w === 'object' && w != null && typeof w.width === 'number') return w.width;
        return 0;
    });
    const total = numWidths.reduce((s, n) => s + n, 0);
    if (total <= 0) {
        const pct = (100 / widths.length).toFixed(2);
        node.table.widths = widths.map(() => pct + '%');
    } else {
        node.table.widths = numWidths.map((n) => (total ? ((n / total) * 100).toFixed(2) : 0) + '%');
    }
    node.table.width = '100%';
}